export const menuConfig = [
  // PUBLIC ROUTES (Always visible for all users)
  {
    id: "welcome",
    title: "Welcome",
    icon: "/media/svg/icons/Home/Home.svg",
    path: "/welcome",
    isPublic: true,
  },

  // SITE SECTION
  {
    id: "site",
    title: "Site",
    icon: "/media/svg/icons/Shopping/Box2.svg",
    hasSubmenu: true,
    submenu: [
      {
        id: "template",
        title: "Regular Schedule",
        path: "/template",
        requiresSiteId: true,
      },
      {
        id: "pre-schedule",
        title: "Pre-Schedule",
        path: "/pre-schedule",
        requiresSiteId: true,
      },
      {
        id: "schedule-daily",
        title: "Today's Schedule",
        path: "/schedule/daily",
        requiresSiteId: true,
      },
      {
        id: "car",
        title: "Car",
        path: "/s-car",
        requiresSiteId: true,
      },
      {
        id: "location",
        title: "Location",
        path: "/s-location",
        requiresSiteId: true,
      },
      {
        id: "news",
        title: "News",
        path: "/s-news",
        requiresSiteId: true,
      },
      {
        id: "privacy-policy",
        title: "Privacy Policy",
        path: "/privacyPolicy",
        requiresSiteId: true,
      },
      {
        id: "terms-conditions",
        title: "Terms & Conditions",
        path: "/termsCondition",
        requiresSiteId: true,
      },
      {
        id: "user-manual",
        title: "User Manual",
        path: "/s-userManual",
        requiresSiteId: true,
      },
      {
        id: "notes-to-passenger",
        title: "Notes to Passenger",
        path: "/notesToPassenger",
        requiresSiteId: true,
      },
      {
        id: "notes-to-passenger-web",
        title: "Notes to Passenger (Web)",
        path: "/notes-to-passenger-web",
        requiresSiteId: true,
      },
      {
        id: "download-app",
        title: "Download App (Web)",
        path: "/download-app",
        requiresSiteId: true,
      },
      {
        id: "app-info",
        title: "App Info",
        path: "/s-app-info",
        requiresSiteId: true,
      },
    ],
  },

  // NOTIFICATION SECTION
  {
    id: "notification",
    title: "Notification",
    icon: "/media/svg/icons/Shopping/Box2.svg",
    hasSubmenu: true,
    submenu: [
      {
        id: "news",
        title: "News",
        path: "/news",
      },
      {
        id: "driver-news",
        title: "Driver News",
        path: "/drivernews",
      },
    ],
  },

  // REPORT SECTION
  {
    id: "report",
    title: "Report",
    icon: "/media/svg/icons/Shopping/Box2.svg",
    hasSubmenu: true,
    submenu: [
      {
        id: "late-report",
        title: "Issue Report",
        path: "/lateReport",
      },
      {
        id: "schedule-report",
        title: "Schedule Report",
        path: "/ScheduleReport",
      },
    ],
  },

  // COMPANY SERVICE SECTION (No permission check - always shown for non-STAFF)
  {
    id: "company-service",
    title: "Company Service",
    icon: "/media/svg/icons/Shopping/Box2.svg",
    hasSubmenu: true,
    submenu: [
      {
        id: "company-service-list",
        title: "Company Service",
        path: "/companyService/list",
      },
      {
        id: "service-tag",
        title: "Service Tag",
        path: "/companyService/serviceTag",
      },
      {
        id: "inquiry-service",
        title: "Inquiry Service",
        path: "/companyService/inquiryService",
      },
    ],
  },
  // GENERAL SETTING SECTION
  {
    id: "general-setting",
    title: "General Setting",
    icon: "/media/svg/icons/Shopping/Box2.svg",
    hasSubmenu: true,
    submenu: [
      {
        id: "site-management",
        title: "Site",
        path: "/site",
      },
      {
        id: "user-management",
        title: "User",
        hasSubmenu: true,
        submenu: [
          {
            id: "driver",
            title: "Driver",
            path: "/user",
          },
          {
            id: "admin",
            title: "Admin",
            path: "/admin",
          },
          {
            id: "mo",
            title: "MO",
            path: "/mo",
          },
          {
            id: "staff",
            title: "Staff",
            path: "/staff",
          },
          {
            id: "staff-permission",
            title: "Staff Permission",
            path: "/staff/permission",
          },
        ],
      },
      {
        id: "car-management",
        title: "Car",
        path: "/car",
      },
      {
        id: "location-management",
        title: "Location",
        path: "/location",
      },
      {
        id: "cancel-schedule",
        title: "Cancel Schedule",
        path: "/cancel-schedule",
      },
      {
        id: "company-info",
        title: "Company Info",
        path: "/companyInfo",
      },
      {
        id: "contact-us",
        title: "Contact Us",
        path: "/contact-us",
      },
      {
        id: "driver-app-config",
        title: "Driver App Config",
        path: "/driverFcmConfig",
      },
      {
        id: "internal-info",
        title: "Internal Info",
        path: "/otherInfo",
      },
      {
        id: "arrived-line",
        title: "Arrived Line",
        path: "/reachedValue",
      },
      {
        id: "logo-image",
        title: "Logo Image",
        path: "/logoImage",
      },
      {
        id: "report-reasons",
        title: "Report Reasons Selection",
        path: "/reason",
      },
    ],
  },

  // EXCEL REPORT SECTION
  {
    id: "excel-report",
    title: "Excel Report",
    icon: "/media/svg/icons/Shopping/Box2.svg",
    hasSubmenu: true,
    submenu: [
      {
        id: "daily-report",
        title: "Daily Report",
        path: "/export/daily-report",
      },
      {
        id: "monthly-report",
        title: "Monthly Report (MP)",
        path: "/export/monthly-report",
      },
      {
        id: "monthly-manulife-report",
        title: "Monthly ManuLife Report",
        path: "/export/monthly-manulife-report",
      },
    ],
  },
];
